/**
 * placeholder(빈 블록 안내 텍스트) + 포커스 컨텐츠 판별.
 * editable 은 런타임에 바뀌므로 getEditable() 로 현재값을 읽는다.
 *
 *   const ph = createPlaceholders({ editorEl, getEditable, placeholderText });
 *   ph.refresh();            // 빈 블록에 data-ph 표기 갱신
 *   ph.focusedContent();     // 현재 커서가 놓인 .content(에디터 내부)
 */
const PLACEHOLDER_TYPES = new Set([
  'paragraph',
  'heading',
  'bulletListItem',
  'numberedListItem',
  'checkListItem',
  'quote',
]);

export function createPlaceholders({ editorEl, getEditable, placeholderText }) {
  function focusedContent() {
    const sel = document.getSelection();
    if (!sel || !sel.rangeCount) return null;
    let n = sel.anchorNode;
    if (n && n.nodeType === 3) n = n.parentNode;
    const c = n && n.closest ? n.closest('.content') : null;
    return c && editorEl.contains(c) ? c : null;
  }
  function isEmptyContent(c) {
    return (
      c &&
      !c.querySelector('img,video,table,iframe,.lumir-image,.lumir-video') &&
      c.textContent.replace(/​/g, '').trim() === ''
    );
  }
  function refresh() {
    if (!placeholderText) return;
    const blocks = [...editorEl.children].filter(
      (b) => b.classList && b.classList.contains('block'),
    );
    const focused = focusedContent();
    blocks.forEach((b, i) => {
      const c = b.querySelector(':scope > .content');
      if (!c) return;
      const show =
        getEditable() &&
        PLACEHOLDER_TYPES.has(b.dataset.type) &&
        isEmptyContent(c) &&
        (c === focused || (i === 0 && !focused));
      if (show) {
        c.setAttribute('data-empty', 'true');
        c.setAttribute('data-ph', placeholderText);
      } else {
        c.removeAttribute('data-empty');
      }
    });
  }

  return { refresh, focusedContent, isEmptyContent };
}
